export default [
  {
    content: "Inspectie tehnica periodica",
  },
  {
    content: "Vulcanizare",
  },
  {
    content: "Echilibrare roti",
  },
  {
    content: "Incarcare freon",
  },
]
